import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalMeetingTypesService } from "services/ClientPortalMeetingTypesService";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  MeetingTypeSelectModels: new Array<IntSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const MeetingTypeSelectSlice = createSlice({
  name: "MeetingType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMeetingTypesSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getMeetingTypesSelectModels.rejected, (state) => {
        state.Loading = false;
        state.MeetingTypeSelectModels = new Array<IntSelectModel>();
        state.LastUpdateTime = new Date();
      })
      .addCase(getMeetingTypesSelectModels.fulfilled, (state, action) => {
        state.MeetingTypeSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getMeetingTypesSelectModels = createAsyncThunk("MeetingType/GetSelectModels", async () => {
  const meetingTypesService = container.get<IClientPortalMeetingTypesService>(
    SERVICE_TYPES.CPLClientPortalMeetingTypesService
  );
  return await meetingTypesService.getMeetingTypeSelectModels();
});

export const selectMeetingTypeSelectModels = (state: RootState) => state.meetingTypes.MeetingTypeSelectModels;
export const selectLoadingMeetingTypeSelectModels = (state: RootState) => state.meetingTypes.Loading;
export const selectLastUpdateTime = (state: RootState) => state.meetingTypes.LastUpdateTime;

export default MeetingTypeSelectSlice.reducer;
